import moment from 'moment';

export const getAgeFromPersonalID = (personalID: string): number => {
  const year = Number(personalID.substring(0, 2));
  const birthdateString = personalID.substring(0, 6);
  const today = new Date();
  const currrentYear = today.getFullYear() - 2000;
  const thresholdMinYear = currrentYear - 10;
  const birthdate = moment(
    (year > thresholdMinYear || year > currrentYear ? '19' : '20') +
      birthdateString,
    'YYYYMMDD',
  ).toDate();
  const ageInMiliseconds = today.getTime() - birthdate.getTime();
  return Math.floor(ageInMiliseconds / 1000 / 60 / 60 / 24 / 365);
};
